import { GlobalStyles, makeStyles } from '@shared/theme';
import { neutralsPalette, primaryPalette } from '@shared/theme/colors';
import Setting from './ErrorPage/Settings.component.svg';
import { getMessages } from './ErrorPage/getMessages';
import ExternalPageCard from './ExternalPageCard';

const useStyles = makeStyles(() => ({
  typography: {
    fontFamily: 'var(--global-font-family, sans-serif)',
    margin: 0,
    color: neutralsPalette[900],
  },
  title: {
    fontSize: '1rem',
  },
  description: {
    fontSize: '0.875rem',
  },
  button: {
    backgroundColor: `var(--primary-color, ${primaryPalette[500]})`,
    display: 'inline-flex',
    padding: '12px 24px',
    fontWeight: 700,
    justifyContent: 'center',
    alignItems: 'center',
    color: '#fff',
    // We cannot use the borderRadius function from the theme here
    borderRadius: 9999,
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      filter: 'grayscale(20%)',
    },
  },
  illustration: {
    '.fg, .bg': {
      fill: `var(--primary-color, ${primaryPalette[500]})`,
    },
    '.bg': {
      opacity: 0.4,
    },
  },
}));

type Props = {
  onContinue: () => void;
};
const CrashPage = ({ onContinue }: Props) => {
  const { classes, cx } = useStyles();
  const locale = document.documentElement.lang;
  const { title, description, button } = getMessages(locale);

  return (
    <>
      <GlobalStyles backgroundColor={neutralsPalette[400]} />
      <ExternalPageCard>
        <Setting className={classes.illustration} height={130} />
        <h1 className={cx(classes.typography, classes.title)}>{title}</h1>
        <p className={cx(classes.typography, classes.description)}>{description}</p>
        {/* doubles the gap */}
        <div />
        {/*  eslint-disable-next-line react/forbid-elements  */}
        <button className={cx(classes.typography, classes.button)} onClick={onContinue}>
          {button}
        </button>
      </ExternalPageCard>
    </>
  );
};

export default CrashPage;
